<template>
  <span>
    <span
      :class="[
        contentClass,
        canTrack ? linkClass : '',
        { uppercase: isUppercase }
      ]"
      :role="canTrack ? 'button' : null"
      :tabindex="canTrack ? 0 : null"
      @click="track"
      @keydown.enter="track"
    >
      {{ reference || "-" }}
      <i v-if="canTrack" class="flaticon-link"></i>
    </span>

    <base-alert type="info" class="mb-0" v-if="loading">
      <div class="d-flex align-items-center">
        <img
          src="~rhomtrip_assets/src/img/icons/loaders/loader-1.gif"
          alt="loader"
          class="d-inline mr-2"
        />
        <span class="d-inline info-min">
          <strong class="d-block">Verifying flight...</strong>
          Redirecting to flight tracking page…
        </span>
      </div>
    </base-alert>
  </span>
</template>

<script>
import { getTransportReference } from "../../../helpers/reservation.helpers";

const FLIGHT_TYPES = ["airport", "arrival", "departure"];

export default {
  name: "TransportReference",
  props: {
    reservation: {
      type: Object,
      required: true
    },
    contentClass: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    linkClass: {
      type: String,
      default: "ml-0 link"
    }
  },
  computed: {
    reference() {
      return getTransportReference(this.reservation);
    },
    canTrack() {
      return (
        FLIGHT_TYPES.includes(this.reservation.type) &&
        !!this.reservation.flight_number
      );
    },
    isUppercase() {
      return this.reservation.type !== "hourly" && !!this.reference;
    }
  },
  methods: {
    track() {
      if (this.canTrack && !this.loading) {
        this.$emit("track", this.reservation.flight_number);
      }
    }
  }
};
</script>
